module.exports = __webpack_public_path__ + "9a6a5a392c2906dad6113a9fee7734ab.png";